import { connect } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { DownloadManagerState } from '../../DownloadManager/reducer';
import DownloadManagerUtils from '../../../utils/downloadManager';

interface UpdatesDriveItemListPageProps extends AbstractDriveItemListPageProps {
	downloadManager: DownloadManagerState;
}

export class UpdatesDriveItemListPage extends AbstractDriveItemListPage<UpdatesDriveItemListPageProps> {

	headerLabel = 'messages.updates';
	noItemsLabel = 'messages.no_updates';
	hasPageTitle = true;

	initializeView(props: UpdatesDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		const downloadList = this.props.downloadManager.items;
		const driveItemsStore = this.props.driveList.driveItems;

		return Object.keys(downloadList)
			.map(id => parseInt(id, 10))
			.filter(driveItemId => {
				const driveItem = driveItemsStore[driveItemId];
				return driveItem && !DownloadManagerUtils.isLatestVersion(driveItem.version, downloadList[driveItemId].version);
			});
	}
}

const mapStateToProps = (state: StoreState) => {
	const { downloadManager } = state;
	return { downloadManager };
};

export default connect(mapStateToProps)(UpdatesDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Updates.tsx